module.exports = __webpack_public_path__ + "img/telenor-logo-flat-blue.aa6e8b32.svg";